<ng-template [ngIf]="componentOrTemplate" [ngIfElse]="actionsTmpl">
  <ng-template
    [ngIf]="isTemplateRef"
    [ngIfThen]="templateRefTmpl"
    [ngIfElse]="componentTmpl"
  ></ng-template>
</ng-template>

<ng-template #actionsTmpl>
  <sn-action-list *ngIf="items?.length" [items]="items"></sn-action-list>
</ng-template>

<ng-template #componentTmpl>
  <ng-template
    [ngComponentOutlet]="componentOrTemplate"
    [ngComponentOutletInjector]="componentInjector"
  >
  </ng-template>
</ng-template>

<ng-template #templateRefTmpl>
  <ng-template [ngTemplateOutlet]="componentOrTemplate" [ngTemplateOutletContext]="templateContext">
  </ng-template>
</ng-template>
